import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const initialValue = {};
const CrmMessagingContext = /*#__PURE__*/createContext(initialValue);
export function useCrmMessagingContext() {
  return useContext(CrmMessagingContext);
}
export function CrmMessagingProvider(t0) {
  const $ = _c(5);
  const {
    messagingId,
    children
  } = t0;
  let t1;
  if ($[0] !== messagingId) {
    t1 = {
      messagingId
    };
    $[0] = messagingId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contextValue = t1;
  let t2;
  if ($[2] !== children || $[3] !== contextValue) {
    t2 = /*#__PURE__*/_jsx(CrmMessagingContext.Provider, {
      value: contextValue,
      children: children
    });
    $[2] = children;
    $[3] = contextValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}